import React, { useEffect } from "react";
import Header from "@/components/Header";
import { useLocation } from "react-router-dom";

export default function Contact() {
  const { hash } = useLocation();
  const isModel = hash === "#model-days";
  useEffect(() => {
    if (isModel) {
      const el = document.getElementById("model-days");
      el && el.scrollIntoView({ behavior: "smooth" });
    }
  }, [isModel]);

  return (
    <div className="clae-home" data-testid="contact-page">
      <Header />
      <section className="clae-page">
        <p className="clae-eyebrow">CONTACT</p>
        <h1 className="clae-h1 clae-h1--sm">GET IN TOUCH.</h1>
        <div className="clae-contact">
          <div>
            <p className="clae-eyebrow clae-eyebrow--sub">STUDIO</p>
            <p className="clae-body">
              <a href="https://www.google.com/maps/search/?api=1&query=106+Finchley+Road+South+Hampstead+London+NW3+5JJ"
                 target="_blank" rel="noreferrer" data-testid="contact-address">
                106 Finchley Road<br />South Hampstead<br />London NW3 5JJ
              </a>
            </p>
            <p className="clae-eyebrow clae-eyebrow--sub" style={{ marginTop: 28 }}>EMAIL</p>
            <p className="clae-body">
              <a href="mailto:hello@claeaesthetics.co.uk" data-testid="contact-email">hello@claeaesthetics.co.uk</a>
            </p>
            <p className="clae-eyebrow clae-eyebrow--sub" style={{ marginTop: 28 }}>INSTAGRAM</p>
            <p className="clae-body">
              <a href="https://instagram.com/clae.aesthetics" target="_blank" rel="noreferrer">@clae.aesthetics</a>
            </p>
          </div>
          <div id="model-days">
            <p className="clae-eyebrow clae-eyebrow--sub">CLAÈ MODEL DAYS</p>
            <p className="clae-body">
              Model appointments are occasionally offered at exclusive rates in
              exchange for treatment photography. To be considered, please email
              us with your name, area of interest and Instagram handle — we'll
              reach out when a matching Model Day is scheduled.
            </p>
            <a href="mailto:hello@claeaesthetics.co.uk?subject=CLAÈ%20Model%20List"
               className="clae-btn clae-btn--primary" data-testid="model-mailto"
               style={{ marginTop: 20, display: "inline-block" }}>
              EMAIL TO JOIN
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
